import React, { useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [status, setStatus] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setStatus({ type: 'danger', msg: 'Passwords do not match' });
      return;
    }

    try {
const res = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/set-password-token`, {
  token,
  password
});


      setStatus({ type: 'success', msg: res.data.message });
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setStatus({
        type: 'danger',
        msg: err.response?.data?.error || 'Failed to set password'
      });
    }
  };

  return (
    <div className="container mt-5" style={{ maxWidth: '500px' }}>
      <h3 className="mb-4">Set Your Password</h3>
      {status && <div className={`alert alert-${status.type}`}>{status.msg}</div>}

      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <label htmlFor="password" className="form-label">New Password</label>
          <input
            type="password"
            className="form-control"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="confirm" className="form-label">Confirm Password</label>
          <input
            type="password"
            className="form-control"
            id="confirm"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            required
          />
        </div>

        <button type="submit" className="btn btn-primary w-100">Set Password</button>
      </form>
    </div>
  );
};

export default SetPassword;
